module.exports = __webpack_public_path__ + "static/media/advantages_4.3313c6d3.svg";